import { render, staticRenderFns } from "./SystemRouterManager.vue?vue&type=template&id=2644d162&scoped=true&"
import script from "./SystemRouterManager.vue?vue&type=script&lang=js&"
export * from "./SystemRouterManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644d162",
  null
  
)

export default component.exports